/*========================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
=========================*/

export default [
  {
    url: '/admin-dashboard',
    name: 'Dashboard',
    slug: 'admin-dashboard',
    icon: "HomeIcon",
    i18n: 'Edit'
  },
  {
    url: "apps/client/list",
    name: "Clients",
    slug: "clients",
    icon: 'LayersIcon',
    submenu: [
      {
        url: "/apps/leads/list",
        name: "Leads List",
        slug: "leads-list",
        icon: 'ListIcon',
      },
      {
        url: '/apps/leads/add',
        name: 'Add Lead',
        slug: 'add-lead',
        icon: 'CornerDownRightIcon',
      },
      {
        url: "/apps/client/list",
        name: "Clients List",
        slug: "clients-list",
        icon: 'UsersIcon',
      },
      {
        url: '/apps/client/add',
        name: 'Add Client',
        slug: 'add-client',
        icon: 'UserPlusIcon',
      }
    ]
  },
  {
    url: "apps/partners/list",
    name: "Partners",
    slug: "partners",
    icon: 'SmileIcon',
    submenu: [
      {
        url: "/apps/partners/list",
        name: "Partners List",
        slug: "partners-list",
        icon: 'AlignJustifyIcon',
        i18n: 'List',
      },
      {
        url: '/apps/partners/add',
        name: 'Add Partner',
        slug: 'add-partner',
        icon: 'PlusSquareIcon',
        i18n: 'Plus'
      },
      {
        url: '/apps/partners/partnercodes/list',
        name: 'Partner Codes',
        slug: 'partner-codes',
        icon: 'CodeIcon',
        i18n: 'Codepen '
      },
    ]
  },
  {
    url: null,
    name: 'Payments',
    slug: 'payments',
    icon: 'DollarSignIcon',
    submenu: [
      
      {
        url: "/apps/prepay/list",
        name: "Prepays List",
        slug: "app-prepays-list",
        icon: 'MenuIcon',
        i18n: 'Menu ',
      },
      {
        url: '/apps/prepay/add',
        name: 'Add Prepay',
        slug: 'app-prepay-add',
        icon: 'PlusSquareIcon',
        i18n: 'PlusSquare'
      },
      {
        url: '/apps/payments/payment-list',
        name: 'Payments List',
        slug: 'Payments List',
        icon: 'FileTextIcon',
        i18n: 'Menu'
      },
      {
        url: '/apps/payments/payment-add',
        name: 'Add Payment',
        slug: 'Add Payment',
        icon: 'FilePlusIcon',
        i18n: 'Plus'
      },
      {
        url: '/apps/earnings',
        name: 'Earnings List',
        slug: 'Earnings List',
        icon: 'AwardIcon',
        i18n: 'List'
      },
      {
        url: '/apps/minuteslog/minuteslog',
        name: 'Minutes Log List',
        slug: 'Minutes Log List',
        icon: 'ClockIcon',
        i18n: 'List'
      }
    ]
  },
  {
    name: 'Users',
    icon: 'ServerIcon',
    i18n: 'Users',
    url: "/apps/users/list",
    slug: "user",
    submenu: [
      {
        url: '/apps/users/list',
        name: 'Users List',
        slug: 'app-user-list',
        icon: 'CreditCardIcon',
        i18n: 'Menu'
      },
      {
        url: '/apps/users/add',
        name: 'Add User',
        slug: 'app-user-add',
        icon: 'EditIcon',
        i18n: 'UserPlus'
      }
    ]
  },
  {
    url:'/apps/settings/settings',
    name: 'Settings',
    icon: 'SettingsIcon',
    i18n: 'Menu'
  },
]
